import {connect} from '../../../../../../../../commons/components/runtime-context/connect'
import {getSeatingErrorPlanPlaceId} from '../../../../../selectors/seating/errors'
import {getTotalPlaceQuantity} from '../../../../../selectors/seating/place'
import {getAnyPlaceById, getPlaces} from '../../../../../selectors/seating/places'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {PlaceCapacityReachedRuntimeProps} from './interfaces'
import {PlaceCapacityReached as Presentation} from './place-capacity-reached'

const mapRuntime = ({state, actions: {setSeatingError}}: DetailsPageAppProps): PlaceCapacityReachedRuntimeProps => ({
  placeCapacity: getAnyPlaceById(getPlaces(state), getSeatingErrorPlanPlaceId(state)).capacity,
  totalPlaceQuantity: getTotalPlaceQuantity(getPlaces(state), getSeatingErrorPlanPlaceId(state)),
  setSeatingError,
})

export const PlaceCapacityReached = connect<{}, PlaceCapacityReachedRuntimeProps>(mapRuntime)(Presentation)
